import Component from "./Transactions";
export default Component;  
